<template>
  <v-container fluid>
    <v-card class="mx-auto">
      <v-card-title>
        <h3>{{ $t("Trucks") }}</h3>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          color="#2C3A47"
        >
        </v-text-field>
      </v-card-title>
      <v-data-table
        item-key="id"
        :headers="headers"
        :items="getTrucks"
        :search="search"
      >
        <template v-slot:[`item.station`]="{ item }">
          <div v-if="item.station">{{ item.station.name }}</div>
          <div v-else>-</div>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            color="success"
            class="mx-2"
            fab
            x-small
            @click="editTrucks(item)"
            outlined
          >
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
        </template>

        <template v-slot:no-results>
          <v-alert :value="true" color="pink" icon="warning" dark>
            Your Search {{ search }} does not exist.
          </v-alert>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
        <v-card-title class="info white--text">
          {{ $t("Edit ") }}{{ $t("Trucks") }}
        </v-card-title>
        <v-card-text>
          <v-form
            @submit.prevent="savePost"
            ref="truckData"
            lazy-validation
            enctype="multipart/form-data"
            autocomplete="off"
          >
            <v-text-field
              name="License Plate"
              id="id"
              label="licenseplate"
              hide-details="auto"
              v-model="truckData.licenseplate"
              :rules="[(v) => !!v || 'License Plate is required']"
              disabled
              required
            ></v-text-field>

            <v-select
              :items="getStations"
              item-text="name"
              item-value="_id"
              label="Station"
              v-model="truckData.station"
              clearable
            ></v-select>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="success" text @click="savePost()">Save</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="close"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" buttom left :color="color">
      {{ text }}
      <v-btn color="white" text @click="snackbar = false"> close </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
//import axios from "axios";
import {
  isIOS,
  isMobile,
  isAndroid,
  isSafari,
  isWinPhone,
} from "mobile-device-detect";
export default {
  name: "AccountPage",
  components: {},
  computed: {
    getTrucks() {
      return this.$store.getters.allTrucks;
    },
    getStations() {
      return this.$store.getters.allStations;
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  mounted() {
    this.loadStations();
  },
  data() {
    return {
      isMobile: isIOS || isSafari || isAndroid || isMobile || isWinPhone,

      create: true,
      mini: false,
      dialog: false,
      fab: false,

      search: "",
      snackbar: false,
      text: "",
      color: "",
      btnName: "",

      headers: [
        { text: "License Plate", value: "licenseplate", sortable: true },
        {
          text: "Vehicle ID",
          value: "truck.vehicle_id",
          sortable: false,
          align: "start",
        },
        {
          text: "Station",
          value: "station",
          sortable: false,
          align: "start",
        },
        { text: "Action", value: "actions", sortable: false, align: "center" },
      ],
      truckData: {
        licenseplate: "",
        vehicle_id: "",
        stations: "",
        office: "",
        sector: "",
      },
      default: {
        licenseplate: "",
        vehicle_id: "",
        stations: "",
        office: "",
        sector: "",
      },
      editedIndex: -1,
    };
  },
  methods: {
    opendialog() {
      this.dialog = true;
    },
    loadStations() {
      this.$store.dispatch("getTrucks");
      this.$store.dispatch("getStations");
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.truckData = Object.assign({}, this.default);
        this.editedIndex = -1;
        this.$refs.truckData.resetValidation();
      }, 300);
    },
    savePost() {
      if (this.editedIndex > -1) {
        this.saveTrucks();
      }
    },
    editTrucks(item) {
      this.editedIndex = this.getTrucks.indexOf(item);
      this.truckData = Object.assign({}, item);
      this.create = false;
      this.dialog = true;
    },
    saveTrucks() {
      const station = this.getStations.find(
        (data) => data._id === this.truckData.station
      );
      if (station) {
        this.truckData.office = station.office._id;
        this.truckData.sector = station.sector._id;
      } else {
        this.truckData.office = null;
        this.truckData.sector = null;
      }
      if (this.$refs.truckData.validate()) {
        this.$store.dispatch("editTrucks", this.truckData).then(
          () => {
            this.dialog = false;
            this.$store.dispatch("getTrucks");
            this.color = "success";
            this.text = "Truck has been successfully saved.";
            this.snackbar = true;
          },
          (error) => {
            this.color = "error";
            this.text = error.response.data.error.message;
            this.snackbar = true;
          }
        );
      }
    },
  },
};
</script>
